<template>
<el-row class="footer-box">
  <el-row ftype="flex" justify="space-between" class="footer-link">
    <el-col :span="15">
      <el-col :span="4">
        <h5>会员功能</h5>
        <router-link v-if="isVipStr == 'false'" to="" @click.native="showVipHandler" v-click-with-auth-login>激活会员</router-link>
        <router-link to="/vip">开通VIP</router-link>
      </el-col>
      <el-col :span="4">
        <h5>产品功能</h5>
        <router-link to="/school">查学校</router-link>
        <router-link to="/major">查专业</router-link>
        <router-link to="/interest">智能评测</router-link>
        <router-link to="/zhiyuan">志愿填报</router-link>
        <router-link to="/toolsRank">批次线查询</router-link>
        <router-link to="/toolsRank">位次查询</router-link>
      </el-col>
      <el-col :span="4">
        <h5>个人中心</h5>
        <router-link to="/person">高考信息</router-link>
        <router-link to="/person">志愿表</router-link>
        <router-link to="/person">订单列表</router-link>
        <router-link to="/person">修改密码</router-link>
      </el-col>
      <el-col :span="8">
        <h5>联系我们</h5>
        <h6>客服热线</h6>
        <p>400-1117-111</p>
        <!-- <h6>商务合作</h6>
        <p class="footer-text">18738130734</p> -->
      </el-col>
    </el-col>
    <el-col :span="4" class="footer-code">
      <h4>加我进2023高考群</h4>
      <img v-if="provinceCode == '51'" src="../assets/images/service-bottom2.png">
      <img v-else="provinceCode == '41'" src="../assets/images/service-bottom1.png">
    </el-col>
  </el-row>
  <el-row class="footer-remark">
    <el-row type="flex" justify="space-between" class="footer-img" align="middle">
        <img v-if="website.logo_top" :src="file_url + website.logo_bottom" alt="logo">
        <img v-else src="../assets/images/logo-bottom.png" alt="logo">
        <p>备案号：豫ICP备13020382号-6</p>
    </el-row>
  </el-row>
</el-row>
  
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      file_url: process.env.VUE_APP_FILE_API
    }
  },
  computed: {
    ...mapState({
      isVipStr: state => state.user.isVipStr,
      website: state => state.user.website,
      provinceCode: state => state.user.provinceCode
    })
  },
  methods: {
    showVipHandler() {
      localStorage.setItem("isNewUser","false");
      this.$store.commit('user/SHOWADDVIP', true);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
  .footer-box {
    height: 386px;
    background: #514946;
    .footer-link {
      @include gwidth;
      padding-top: 40px;
      height: calc(100% - 64px);
      h5 {
        font-size: 14px;
        color: #ffffff;
        margin: 0;
        font-weight: 500;
        margin-bottom: 20px;
      }
      h6 {
        font-size: 12px;
        color: rgba(255,255,255,0.60)!important;
        margin-bottom: 16px;
        margin: 0;
        font-weight: 400;
        margin-bottom: 9px;
      }
      p {
        font-size: 20px;
        margin: 0;
        margin-bottom: 20px;
        color: #ffffff;
      }
      .footer-text {
        color: #ffffff;
        font-size: 20px;
      }
      a {
        text-decoration:none; 
        display: block;
        font-size: 12px;
        color: rgba(255,255,255,0.60)!important;
        margin-bottom: 12px;
        font-weight: 400;
        font-family:'Microsoft YaHei';
      }
      a:hover {
        color: $common-color!important;
      }
    }
    .footer-code {
      text-align: center;
      float: right;
      h4 {
        margin: 0;
        font-size: 16px;
        color: #fff;
        margin-left: 12px;
      }
      img {
        width: 136px;
        height: 136px;
        background: #fff;
        float: right;
        margin-top: 14px;
        margin-right: 22px;
      }
    }
  }
  .footer-remark {
    height: 64px;
    line-height: 63px;
    border: none;
    border-top: 1px solid #655b58;
    .footer-img {
      // @include gwidth;
      padding: 0 4%;
      img {
        // width: 133px;
        // height: 40px;
        width: 170px;
        height: 40px;
      }
      p {
        font-size: 12px;
        color: rgba(255,255,255,0.60);
        margin: 0;
        font-family: 'MicrosoftYaHei, MicrosoftYaHei-Regular';
      }
    }
  }
</style>